import styled, { css } from 'styled-components';
import { HEADER_CONTAINER } from '../../../styles/Layout';
import { PAGE_SIDE_PADDING } from '../../../styles/Layout';
import { ThemeColours } from '../../../styles/ThemeColours';
import {
  Breakpoint,
  DESKTOP_HEADER_HEIGHT,
  FONT_STACK,
  MOBILE_HEADER_HEIGHT,
  ZIndex,
} from '../../../styles/constants';
import { TOP_NAVIGATION_BAR_HEIGHT } from '../../TopNavigationBar/TopNavigationBar.styles';

export const Container = styled.div<{ focused?: boolean; shorterNavBar?: boolean }>`
  ${FONT_STACK};
  background-color: ${ThemeColours.white};
  ${props =>
    !props.focused &&
    css`
      border-bottom: solid 1px ${ThemeColours.mono200};
    `}

  box-sizing: border-box;
  display: flex;
  height: ${MOBILE_HEADER_HEIGHT};
  min-height: ${MOBILE_HEADER_HEIGHT};
  position: relative;

  width: 100%;
  z-index: ${ZIndex.OVERLAY};

  ${Breakpoint.SMALL} {
    height: ${({ shorterNavBar }) =>
      shorterNavBar ? TOP_NAVIGATION_BAR_HEIGHT : DESKTOP_HEADER_HEIGHT};
    min-height: ${({ shorterNavBar }) =>
      shorterNavBar ? TOP_NAVIGATION_BAR_HEIGHT : DESKTOP_HEADER_HEIGHT};
  }
`;

export const NewContainer = styled.div<{
  focused?: boolean;
  isSearchMultiLine?: boolean;
  shorterNavBar?: boolean;
}>`
  ${FONT_STACK};
  background-color: ${ThemeColours.white};
  ${props =>
    !props.focused &&
    css`
      border-bottom: solid 1px ${ThemeColours.mono200};
    `}

  box-sizing: border-box;
  display: flex;
  max-height: ${props => (!props.isSearchMultiLine ? '130' : '184')}px;
  padding: ${props => (!props.isSearchMultiLine ? '10px 0 10px 0' : '16px 0 24px 0')}px;
  position: ${props => (!props.isSearchMultiLine ? 'relative' : 'absolute')};

  width: 100%;
  z-index: ${ZIndex.OVERLAY};

  ${Breakpoint.SMALL} {
    height: ${({ shorterNavBar }) =>
      shorterNavBar ? TOP_NAVIGATION_BAR_HEIGHT : DESKTOP_HEADER_HEIGHT};
    min-height: ${({ shorterNavBar }) =>
      shorterNavBar ? TOP_NAVIGATION_BAR_HEIGHT : DESKTOP_HEADER_HEIGHT};
  }
`;

export const Inner = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  height: 100%;
  width: 100vw;
  ${HEADER_CONTAINER}
`;

export const ExperimentInner = styled(Inner)`
  padding-left: ${PAGE_SIDE_PADDING};
  padding-right: ${PAGE_SIDE_PADDING};
`;
